import React from 'react';
import { useLang } from '@shootout-comps/i18n';
import type { League } from '@shootout-comps/types';

interface LeaguesListPageProps {
  leagues: League[];
  onOpen: (id: string) => void;
  createForm: React.ReactNode;
  onBrowsePublic: () => void;
}

// Card-grid list — copy-adapted from TournamentsPage.tsx's list rendering, simplified since
// leagues have no status/date/players-count fields yet at this milestone.
export default function LeaguesListPage({ leagues, onOpen, createForm, onBrowsePublic }: LeaguesListPageProps) {
  const { t } = useLang();
  return (
    <div style={{ maxWidth: '760px', margin: '0 auto', padding: '2rem 1.5rem' }}>
      <h2 style={{ fontFamily: 'Bebas Neue', fontSize: 'clamp(1.8rem,6vw,2.5rem)', color: 'var(--gold)', marginBottom: '0.5rem', textAlign: 'center' }}>
        🏆 {t.navLeagues}
      </h2>
      <button onClick={onBrowsePublic} style={{ display: 'block', margin: '0 auto 1.5rem', background: 'none', border: 'none', color: 'var(--chalk-dim)', fontSize: '0.75rem', cursor: 'pointer', padding: 0, textDecoration: 'underline' }}>
        🌐 Browse Public Leagues
      </button>

      <div style={{ marginBottom: '2rem' }}>{createForm}</div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.65rem' }}>
        {leagues.map(l => {
          const teamCount = l.divisions.reduce((s, d) => s + d.teams.length, 0);
          return (
            <div
              key={l._id}
              onClick={() => onOpen(l._id)}
              style={{ display: 'flex', alignItems: 'center', gap: '1rem', background: 'linear-gradient(135deg, rgba(255,255,255,0.05), rgba(255,255,255,0.02))', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '10px', padding: '1rem 1.15rem', cursor: 'pointer', transition: 'all 0.15s' }}
              className="league-row"
            >
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 600, fontSize: '0.95rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{l.name}</div>
                <div style={{ fontSize: '0.75rem', color: 'var(--chalk-dim)', marginTop: '0.25rem' }}>
                  {l.divisions.length} division{l.divisions.length === 1 ? '' : 's'} · {teamCount} team{teamCount === 1 ? '' : 's'}
                </div>
              </div>
              <span style={{ color: 'var(--chalk-dim)', fontSize: '1rem' }}>›</span>
            </div>
          );
        })}
      </div>
      <style>{`.league-row:hover{transform:translateY(-1px);box-shadow:0 4px 16px rgba(0,0,0,0.3)}`}</style>
    </div>
  );
}
